// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__gRorY","navigation":"Tabs_navigation__jPlFD","tabButton":"Tabs_tabButton__Ahxou","active":"Tabs_active__Bj3EH"};